export enum PosterEditorDesignSubPanels {
  NONE = 'none',
  BACKGROUND_COLOR = 'background-color',
  BACKGROUND_IMAGE = 'background-image',
  BACKGROUND_VIDEO = 'background-video',
  BACKGROUND_IMAGE_TINT_COLOR = 'background-image-tint-color',
  BACKGROUND_IMAGE_MULTIPLY_COLOR = 'background-image-multiply-color',
  BACKGROUND_VIDEO_TINT_COLOR = 'background-video-tint-color',
  BACKGROUND_VIDEO_MULTIPLY_COLOR = 'background-video-multiply-color',
  AI_SUBTITLES = 'ai-subtitles',
  ANIMATION_STYLES = 'animation-styles',
  COLOR_PALETTE_STYLES = 'color-palette-styles',
}

export const AI_WRITER_VIA_DEFAULT_POSTER_CONTEXTUAL_OPTIONS = 'AI_WRITER_VIA_DEFAULT_POSTER_CONTEXTUAL_OPTIONS';
